<style scoped>
    .codemirror {
        font-size: 10px;
    }

    .query-tarefa .codemirror .CodeMirror {
        height: 600px;
    }

    .CodeMirror .readOnly {
        background-color: #cccccc;
    }
    /* BDTI custom */
    .bdti-alert {
    margin: 1% auto;
    padding: 1% 1%;
    border-radius: 3px;
    }

    .bdti-alert-danger {
    background: rgba(255, 0, 0, 0.714);
    color: white;
    }

    /* Aviso do tempo médio de execução (restrição de cron) */
    .aviso-tempo {
        display: block;
        margin-top: 6px;
        line-height: 1.35;
        color: #5a6072;
    }

    .aviso-tempo svg {
        margin-right: 4px;
    }

    .aviso-tempo--restricao {
        color: #8a5a00;
    }

    .aviso-tempo--restricao svg {
        color: #c1751f;
    }

    .aviso-tempo--restricao strong {
        color: #2c2e38;
    }

    /* Reforço visual das opções desabilitadas do select de cron */
    select.form-control option:disabled {
        color: #b0b4bd;
    }
</style>

<template>
    <modal name="tarefaEdit" height="auto" width="1024" :scrollable="true" :clickToClose="false">
        <CloseModal :close="close"/>
        <div class="modalbox query-tarefa">
            <div class="modalbox-content" v-if="!!tarefa">
                <CTabs variant="tabs" class="nav-tabs-boxed">
                    <CTab :title="descricao">
                        <div class="form">
                            <div class="bdti-alert bdti-alert-danger" v-if="error">{{error}}</div>
                            <div class="xrow">
                                <div class="col-1-2">
                                    <div class="xrow">
                                        <div class="col-1-2">
                                            <div class="form-group">
                                                <label for="">Tabela/View ERP</label>
                                                <input type="text" class="form-control" v-model="tarefa.tarefa"
                                                       disabled/>
                                            </div>
                                        </div>
                                        <div class="col-1-2">
                                            <div class="form-group">
                                                <label for="">Tabela/Tarefa Local</label>
                                                <input type="text" class="form-control" v-model="tarefa.tabela"
                                                       disabled/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="xrow">
                                        <div class="col-2-3">
                                            <div class="form-group">
                                                <label for="">{{tarefa ? tarefa.descricao : ''}}</label>
                                                <select class="form-control" v-model="tarefa.cron">
                                                    <option
                                                        v-for="(label, cron) in crons"
                                                        :key="cron"
                                                        v-bind:value="cron"
                                                        :disabled="cronDesabilitado(cron)"
                                                    >
                                                        {{ label }}{{ cronDesabilitado(cron) ? ' — abaixo do tempo médio' : '' }}
                                                    </option>
                                                </select>
                                                <small v-if="carregandoTempo" class="aviso-tempo">
                                                    <fa-icon icon="sync" /> Calculando o tempo médio de execução...
                                                </small>
                                                <small
                                                    v-else-if="temLimiteTempo"
                                                    class="aviso-tempo aviso-tempo--restricao"
                                                >
                                                    <fa-icon icon="exclamation-triangle" />
                                                    Tempo médio de execução:
                                                    <strong>{{ tempoMedioFormatado }}</strong>
                                                    (média das últimas {{ qtdAmostras }}
                                                    {{ qtdAmostras === 1 ? 'execução' : 'execuções' }}).
                                                    Intervalos menores que esse tempo estão desabilitados
                                                    para evitar que uma nova carga inicie antes de a anterior terminar.
                                                </small>
                                            </div>
                                        </div>
                                        <div class="col-1-3">
                                            <div class="form-group">
                                                <label for="">Ativo?</label>
                                                <select class="form-control" v-model="tarefa.ativo">
                                                    <option value="1">Sim</option>
                                                    <option value="0">Não</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="xrow">
                                        <div class="col-1-1">
                                            <div class="form-group">
                                                <label for="">Modo de sincronição</label>
                                                <select class="form-control" v-model="tarefa.modo">
                                                    <option v-for="(modo, tipo) in modos" :value="tipo">{{modo.label}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-1-2" v-if="usaBancoExecucao">
                                          <div class="form-group">
                                            <label for="">Banco de execução</label>
                                            <select class="form-control" v-model="tarefa.banco">
                                              <option value="local">Local (Postgres Versotech)</option>
                                              <option value="erp">ERP</option>
                                            </select>
                                          </div>
                                        </div>
                                    </div>
                                    <div class="xrow"
                                         v-show="tarefa.modo === 'NCR_LOTE' || tarefa.modo === 'NCR_LOTE_INDEX' || tarefa.modo === 'HASH_LOTE'">
                                        <div class="col-1-1">
                                            <div class="form-group">
                                                <label for="">Quantidade de registros por lote (default 10000)</label>
                                                <input type="text" class="form-control" v-model="tarefa.loteQtd"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="xrow" v-show="tarefa.modo === 'NCR_LOTE_INDEX' || tarefa.modo === 'HASH_LOTE'">
                                        <div class="col-1-1">
                                            <div class="form-group">
                                                <label for="">Nome da coluna de índice (default ID)</label>
                                                <input type="text" class="form-control" v-model="tarefa.index"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="xrow">
                                        <div class="col-1-2" v-if="!!modos[tarefa.modo] && modos[tarefa.modo].usaEliminaRegistros">
                                            <div class="form-group">
                                                <label for="">Remover registros inválidos?</label>
                                                <select class="form-control" v-model="tarefa.excluirInvalidos">
                                                    <option :value="1">Sim</option>
                                                    <option :value="0">Não</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-1-2" v-if="!!modos[tarefa.modo] && modos[tarefa.modo].usaMargemMinimaRegistros">
                                            <div class="form-group" title="Os registros obtidos do erp devem ter no mínimo o percentual estipulado abaixo ao ser comparado com o número de registros já existentes no sistema">
                                                <label for="">Perc. mín. registros</label>
                                                <input type="number" class="form-control" v-model="tarefa.percentualMinimo">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="xrow">
                                        <div class="col-1-2" v-if="!!modos[tarefa.modo] && modos[tarefa.modo].usaManutencao">
                                            <div class="form-group">
                                                <label for="">Modo de manutenção</label>
                                                <select class="form-control" v-model="tarefa.manutencao">
                                                    <option value="REINDEX">Reindexar tabela</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-1-2" v-if="!!modos[tarefa.modo] && modos[tarefa.modo].usaModoExecucao">
                                            <div class="form-group">
                                                <label for="">Modo de execução</label>
                                                <select class="form-control" v-model="tarefa.tipoExecucao">
                                                    <option value="DEFAULT">Padrão ( Select em view/tabela )</option>
                                                    <option value="SQL">Executar SQL customizado</option>
                                                </select>
                                            </div>
                                        </div>
                                      <div class="col-1-1" v-if="!!tarefa && !!modos[tarefa.modo]">
                                        <span><b>Funcionamento {{ modos[tarefa.modo].label }}</b></span>
                                        <br>
                                        <small>{{ modos[tarefa.modo].obs }}</small>
                                      </div>
                                    </div>
                                </div>
                                <div class="col-1-2">
                                    <div class="form-group">
                                        <label for="">
                                          <span v-if="usaScript">
                                            Código a ser executado
                                          </span>
                                          <span v-else>
                                            SQL Customizado
                                            <small v-show="!usaQueryCustomizada">(Desabilitado)</small>
                                          </span>
                                        </label>
                                        <div class="codemirror">
                                            <codemirror
                                                v-if="usaQueryCustomizada || usaScript"
                                                v-model="tarefa.sql"
                                                :options="code_options"/>
                                            <codemirror
                                                v-else-if="!usaQueryCustomizada && usaQuery"
                                                :value="`SELECT * FROM ${tarefa.tarefa}`"
                                                :options="code_options"/>
                                            <codemirror
                                                v-else-if="!usaQuery"
                                                :options="code_options"
                                            />
                                        </div>
                                        <p>
                                            <small v-show="usaQuery && tarefa.modo === 'INCREMENTAL'">
                                                ATENÇÃO: para utilização de query no formato incremental, é necessário
                                                adicionar o parâmetro
                                                <strong>:P_DATAATUALIZACAO</strong>, este parâmetro será substituído
                                                pela data/hora de última sincronização,
                                                como no exemplo abaixo:
                                                <br>
                                                <strong>
                        <pre>
SELECT *
  FROM PEDIDO
 WHERE 1=1
   AND PEDIDO.DATAATUALIZACAO >= :P_DATAATUALIZACAO
                        </pre>
                                                </strong>
                                            </small>
                                            <small v-show="usaQuery && (tarefa.modo === 'NCR_LOTE' || tarefa.modo === 'NCR_LOTE_INDEX' || tarefa.modo === 'HASH_LOTE')">
                                                ATENÇÃO: para utilização de query no formato de lote paginado, é
                                                necessário adicionar os parâmetros
                                                <strong>:P_FROM</strong> e <strong>:P_TAKE</strong>, estes parâmetros
                                                serão substituídos respectivamente,
                                                pela página atual e a quantidade de registros que deseja obter, como no
                                                exemplo abaixo:
                                                <br>
                                                <strong>
                        <pre style="margin-bottom: 0">
SELECT *
  FROM PEDIDO
 WHERE 1=1
OFFSET :P_FROM
 LIMIT :P_TAKE
</pre>
                                                </strong>
                                                ou, caso seu banco de dados não aceite as condições de offset e limite,
                                                segue exemplo abaixo:
                                                <strong>
                      <pre style="margin-bottom: 0">
SELECT *
  FROM PEDIDO
 WHERE 1=1
   AND ROWNUM BETWEEN :P_FROM AND :P_FROM + :P_TAKE
                        </pre>
                                                </strong>
                                            </small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CTab>
                </CTabs>
            </div>
        </div>
        <div class="modal-footer">
            <div class="flex-grow-1">
                <button
                    title="Eliminar todos os registros da tabela"
                    class="button button-error align-start"
                    v-on:click="handleTruncate"
                >
                    Limpar registros
                </button>
            </div>
            <div>
                <button
                    :class="{ 'button button-success': true, 'button-disabled': validation.hasError() }"
                    v-on:click="handleSubmit"
                >
                    Atualizar
                </button>
                <button class="button" v-on:click="close">Fechar</button>
            </div>
        </div>
    </modal>
</template>
<script>
  import {Validator} from "simple-vue-validator";
  import {get} from "@/helpers/apiRequest";
  import CloseModal from "../../components/CloseModal";

  import {codemirror} from 'vue-codemirror'
  // theme css
  import 'codemirror/lib/codemirror.css'
  import 'codemirror/theme/monokai.css'
  import 'codemirror/theme/zenburn.css'
  // language js
  import 'codemirror/addon/selection/active-line.js'
  import 'codemirror/addon/display/autorefresh.js'
  import 'codemirror/mode/sql/sql.js'
  import 'codemirror/mode/php/php'
  // autoCloseTags
  import 'codemirror/addon/edit/closetag.js'

  export default {
    name: "tarefaEdit",
    props: [
      "crons",
      "update",
      "originalTarefa",
      "truncate",
      "close",
      "tarefa",
      "descricao",
      "modos"
    ],
    validators: {
      "tarefa.cron": (value) => Validator.value(value).required(),
      "tarefa.tarefa": (value) => Validator.value(value).required(),
    },
    components: {
      CloseModal,
      codemirror
    },
    data: function () {
      return {
        error: false,
        // Validação de tempo de carga: média das últimas execuções bem-sucedidas
        tempoMedioSegundos: null,
        qtdAmostras: 0,
        carregandoTempo: false,
        // cron persistido da carga em edição: nunca é bloqueado, para não
        // forçar a troca do que já estava configurado.
        cronOriginal: null,
      };
    },
    computed: {
      // Há restrição de tempo a aplicar (histórico suficiente já carregado).
      temLimiteTempo() {
        return !this.carregandoTempo
          && this.tempoMedioSegundos !== null
          && this.tempoMedioSegundos > 0
          && this.qtdAmostras > 0;
      },
      tempoMedioFormatado() {
        return this.formatarDuracao(this.tempoMedioSegundos);
      },
      podeLimparTabela() {
        return this.tarefa.modo === 'NCR'
          || this.tarefa.modo === 'NCR_LOTE'
          || this.tarefa.modo === 'NCR_LOTE_INDEX'
          || this.tarefa.modo === 'INCREMENTAL'
          || this.tarefa.modo === 'COMPARATOR'
          || this.tarefa.modo === 'HASH_COMPARATOR'
          || this.tarefa.modo === 'HASH_LOTE'
      },
      usaQuery() {
        return this.tarefa.modo === 'NCR'
          || this.tarefa.modo === 'NCR_LOTE'
          || this.tarefa.modo === 'NCR_LOTE_INDEX'
          || this.tarefa.modo === 'INCREMENTAL'
          || this.tarefa.modo === 'COMPARATOR'
          || this.tarefa.modo === 'HASH_COMPARATOR'
          || this.tarefa.modo === 'HASH_LOTE'
      },
      usaBancoExecucao() {
        return !!(this.tarefa
            && this.modos[this.tarefa.modo]
            && this.modos[this.tarefa.modo].usaBancoExecucao);
      },
      usaScript() {
        return this.tarefa.modo === 'SQL_SCRIPT'
          || this.tarefa.modo === 'PHP_SCRIPT';
      },
      usaQueryCustomizada() {
        return (this.usaQuery && this.tarefa.tipoExecucao === 'SQL')
            || this.usaScript;
      },
      code_options() {
        let mode = 'text/x-sql';

        if (this.modos && this.tarefa && this.modos[this.tarefa.modo] && this.modos[this.tarefa.modo].tipoScript ) {
          mode = this.modos[this.tarefa.modo].tipoScript;
        }

        return {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          mode: mode || 'text/x-sql',
          autoRefresh:true,
          lineWrapping: true,
          readOnly: this.usaQueryCustomizada ? false : 'nocursor',
          disabled: true,
          theme: this.usaQueryCustomizada ? 'monokai' : 'zenburn',
          showCursorWhenSelecting: true,
          highlightSelectionMatches: {
            showToken: /\w/,
            annotateScrollbar: true
          },
        }
      }
    },
    watch: {
      tarefa: function () {
        this.error = false;
        this.cronOriginal = this.tarefa ? this.tarefa.cron : null;
        this.carregarTempoMedio();
      },
    },
    methods: {
      // Carrega o histórico de execuções da tarefa e calcula o tempo médio
      // (em segundos) das últimas 10 sincronizações bem-sucedidas. Esse tempo
      // define o intervalo mínimo de cron permitido para a carga.
      carregarTempoMedio() {
        this.tempoMedioSegundos = null;
        this.qtdAmostras = 0;

        if (!this.tarefa || !this.tarefa.tarefa) {
          this.carregandoTempo = false;
          return;
        }

        // Guarda o alvo da requisição: se o usuário trocar de carga antes da
        // resposta chegar, a resposta atrasada da carga anterior é descartada
        // (sem isso, o tempo médio da carga A sobrescrevia o da carga B).
        const alvo = this.tarefa.tarefa;
        this.carregandoTempo = true;
        get(`/admin/tarefas/log-execucao/${alvo}?page=1`)
          .then((response) => {
            if (!this.tarefa || this.tarefa.tarefa !== alvo) {
              return;
            }
            const itens = (response && response.itens) || [];
            // a listagem vem da mais recente para a mais antiga; pegamos as 10
            // últimas execuções concluídas com sucesso e com tempo válido
            const tempos = itens
              .filter((i) => i && i.sucesso && Number(i.tempo_execucao) > 0)
              .map((i) => Number(i.tempo_execucao))
              .slice(0, 10);

            if (tempos.length > 0) {
              const soma = tempos.reduce((acc, t) => acc + t, 0);
              this.tempoMedioSegundos = soma / tempos.length;
              this.qtdAmostras = tempos.length;
            }
          })
          .catch(() => {
            // silencioso: sem histórico, nenhuma restrição de tempo é aplicada
          })
          .finally(() => {
            // não derruba o "carregando" de uma requisição mais nova
            if (!this.tarefa || this.tarefa.tarefa === alvo) {
              this.carregandoTempo = false;
            }
          });
      },
      // Verdadeiro se o intervalo do cron for menor que o tempo médio de carga.
      cronAbaixoDoTempoMedio(cron) {
        if (!this.temLimiteTempo) {
          return false;
        }
        const intervaloMin = this.intervaloCronMinutos(cron);
        if (intervaloMin === null) {
          return false;
        }
        return intervaloMin * 60 < this.tempoMedioSegundos;
      },
      // Restrição visual do select. O cron já persistido nunca é desabilitado,
      // para manter o formulário válido sem forçar a troca do que já estava
      // configurado (e permitir voltar a ele após experimentar outro valor).
      cronDesabilitado(cron) {
        if (cron === this.cronOriginal) {
          return false;
        }
        return this.cronAbaixoDoTempoMedio(cron);
      },
      // Mesma restrição, aplicada de fato no submit (o disabled do option é
      // apenas cosmético). Só bloqueia cron DIFERENTE do persistido.
      cronBloqueadoNoSubmit() {
        if (!this.tarefa || this.tarefa.cron === this.cronOriginal) {
          return false;
        }
        return this.cronAbaixoDoTempoMedio(this.tarefa.cron);
      },
      // Expande um campo do cron (minuto/hora) na lista de valores que ele
      // dispara dentro do seu ciclo. max é exclusivo (60 p/ minuto, 24 p/ hora).
      expandirCampoCron(campo, max) {
        const valores = new Set();
        String(campo).split(',').forEach((parte) => {
          if (parte === '*') {
            for (let i = 0; i < max; i++) {
              valores.add(i);
            }
          } else if (parte.indexOf('*/') === 0) {
            const passo = parseInt(parte.slice(2), 10);
            if (passo > 0) {
              for (let i = 0; i < max; i += passo) {
                valores.add(i);
              }
            }
          } else {
            const n = parseInt(parte, 10);
            if (!isNaN(n)) {
              valores.add(n);
            }
          }
        });
        return Array.from(valores);
      },
      // Calcula o menor intervalo (em minutos) entre dois disparos de um cron,
      // considerando os campos de minuto e hora. Retorna 1440 (1 dia) quando o
      // cron dispara uma única vez ao dia, e null se não conseguir interpretar.
      intervaloCronMinutos(cron) {
        const partes = String(cron).trim().split(/\s+/);
        if (partes.length < 2) {
          return null;
        }
        const minutos = this.expandirCampoCron(partes[0], 60);
        const horas = this.expandirCampoCron(partes[1], 24);
        if (!minutos.length || !horas.length) {
          return null;
        }

        const tempos = [];
        horas.forEach((h) => minutos.forEach((m) => tempos.push(h * 60 + m)));
        tempos.sort((a, b) => a - b);

        if (tempos.length === 1) {
          return 1440;
        }

        let menorGap = Infinity;
        for (let i = 1; i < tempos.length; i++) {
          menorGap = Math.min(menorGap, tempos[i] - tempos[i - 1]);
        }
        // intervalo entre o último disparo do dia e o primeiro do dia seguinte
        menorGap = Math.min(menorGap, 1440 - tempos[tempos.length - 1] + tempos[0]);
        return menorGap;
      },
      // Formata uma duração em segundos como hora e minuto (ex.: "1h 15min").
      formatarDuracao(segundos) {
        const seg = Math.round(segundos);
        if (seg < 60) {
          return `${seg}s`;
        }
        const totalMin = Math.round(seg / 60);
        const horas = Math.floor(totalMin / 60);
        const min = totalMin % 60;
        if (horas > 0) {
          return min > 0 ? `${horas}h ${min}min` : `${horas}h`;
        }
        return `${totalMin}min`;
      },
      handleTruncate() {
        this.truncate(this.tarefa);
      },
      handleSubmit() {
        let self = this;
        self.error = false;
        this.$validate().then((success) => {
          if (success) {
            // Reaplica no submit a restrição de cron x tempo médio de execução
            // (o disabled dos options é só visual e não impede o valor no model).
            if (this.cronBloqueadoNoSubmit()) {
              this.$swal({
                title: 'Intervalo de execução inválido',
                text:
                  `O intervalo escolhido é menor que o tempo médio de execução ` +
                  `desta carga (${this.tempoMedioFormatado}). Escolha um intervalo ` +
                  `maior para evitar que uma nova carga inicie antes de a anterior terminar.`,
                icon: 'error',
                confirmButtonText: 'Fechar',
              });
              return;
            }
            let request = this.update(this.tarefa);
            request.then((json) => {
              this.close();
              this.$swal({
                title: 'Salvo com sucesso',
                text: json.message,
                showCancelButton: false,
                cancelButtonText: 'Fechar',
                showConfirmButton: true,
                icon: 'success',
              });
            });
            request.catch((error) => {
              self.error = error.message;
              this.$swal({
                title: 'Falha ao Salvar',
                text: error.message,
                showCancelButton: true,
                cancelButtonText: 'Fechar',
                showConfirmButton: false,
                icon: 'error',
              });
            });
          }
        });
      },
    },
  };
</script>
